import React, { useState } from 'react';
import Cropper, { Area } from 'react-easy-crop';
import './ImageCropper.css';

interface IImageCropperProps {
    image: string;
    setPixelCrop: (area: Area) => void;
    aspect: number;
}

export const ImageCropper = (props: IImageCropperProps): JSX.Element => {
    const { image, setPixelCrop, aspect } = props;

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);

    if (!image) return <></>;

    return (
        <div className="App">
            <div className="crop-container">
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={aspect}
                    onCropChange={setCrop}
                    onCropComplete={(_, croppedAreaPixels): void => setPixelCrop(croppedAreaPixels)}
                    objectFit={'contain'}
                    onZoomChange={setZoom}
                />
            </div>
            <div className="crop-text fs-5">Use scroll to zoom</div>
        </div>
    );
};

